"use strict";

var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SameDayVisits = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData"),
  _types = require("../types"),
  _logging = require("../../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var SameDayVisits = /*#__PURE__*/function () {
  function SameDayVisits(a) {
    _classCallCheck(this, SameDayVisits);
    var b = a.matchType,
      c = a.visitCount;
    _defineProperty(this, "matchType", void 0), _defineProperty(this, "conditionValue", void 0), this.matchType = b, this.conditionValue = c;
  }
  return _createClass(SameDayVisits, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      var c = null === b || void 0 === b ? void 0 : b[_kameleoonData.KameleoonData.VisitsData];
      if (!c) return (0, _tsRes.Ok)(!1);
      var d = 0;
      var e = new Date().setHours(0, 0, 0, 0),
        f = c.visits;
      return f.forEach(function (a) {
        a > e && d++;
      }), d += 1, (0, _tsRes.Ok)(this.checkCondition(d));
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      if (!this.matchType || "number" != typeof this.conditionValue) return !1;
      switch (this.matchType) {
        case _types.MatchType.EQUAL:
          return a === this.conditionValue;
        case _types.MatchType.GREATER:
          return a > this.conditionValue;
        case _types.MatchType.LOWER:
          return a < this.conditionValue;
        default:
          return _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected comparing operation for SameDayVisits condition: ", ""])), this.matchType), !1;
      }
    }
  }]);
}();
exports.SameDayVisits = SameDayVisits;